"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[739],{

/***/ 3739:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ contact_form; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/photo.js
var photo = __webpack_require__(727);
// EXTERNAL MODULE: ./components/icon.js
var icon = __webpack_require__(7627);
// EXTERNAL MODULE: ./components/phrase.js
var phrase = __webpack_require__(1995);
// EXTERNAL MODULE: ./node_modules/@react-google-maps/api/dist/esm.js
var esm = __webpack_require__(6380);
;// CONCATENATED MODULE: ./components/locator-map.js




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var _obj;
var mapOptions = (_obj = {
    panControl: false,
    zoomControl: true
}, _defineProperty(_obj, "panControl", false), _defineProperty(_obj, "maxZoom", 18), _defineProperty(_obj, "scrollwheel", false), _defineProperty(_obj, "mapTypeControl", false), _defineProperty(_obj, "overviewMapControl", false), _defineProperty(_obj, "fullscreenControl", false), _defineProperty(_obj, "overviewMapControlOptions", {
    opened: false
}), _defineProperty(_obj, "streetViewControl", false), _defineProperty(_obj, "scaleControl", false), _obj);
var libraries = [
    "places"
];
var containerStyle = {
    width: "100%",
    height: "600px"
};
var LocatorMap = function(param) {
    var _displayLocation = param.displayLocation, displayLocation = _displayLocation === void 0 ? false : _displayLocation;
    var ref = (0,react.useState)(null), mapRef = ref[0], setMapRef = ref[1];
    var ref1 = (0,react.useState)(true), markersInView = ref1[0], setMarkersInView = ref1[1];
    var ref2 = (0,react.useState)({}), markerMap = ref2[0], setMarkerMap = ref2[1]; // eslint-disable-line no-unused-vars
    var ref3 = (0,react.useState)({
        lat: 37.7749,
        lng: 122.4194
    }), center = ref3[0], setCenter = ref3[1];
    var ref4 = (0,react.useState)(6), zoom = ref4[0], setZoom = ref4[1];
    //const [clickedLatLng, setClickedLatLng] = useState(null)
    var ref5 = (0,react.useState)(false), infoOpen = ref5[0], setInfoOpen = ref5[1];
    var isLoaded = (0,esm/* useLoadScript */.Db)({
        // Enter your own Google Maps API key
        googleMapsApiKey: "AIzaSyCpivuPCu-jAq3DzWTQFu8o8TcBac0Dm0k",
        libraries: libraries
    }).isLoaded;
    var fitBounds = function(map) {
        var bounds = new window.google.maps.LatLngBounds();
        if (displayLocation) {
            bounds.extend(displayLocation.pos);
        } else {
            bounds.extend(defaultPlace.pos);
        }
        map.fitBounds(bounds);
    };
    var defaultPlace = {
        id: "default",
        pos: {
            lat: 37.7749,
            lng: -122.4194
        }
    };
    // We have to create a mapping of our places to actual Marker objects
    var markerLoadHandler = function(marker, place) {
        return setMarkerMap(function(prevState) {
            return _objectSpread({}, prevState, _defineProperty({}, place.id, marker));
        });
    };
    var loadHandler = function(map) {
        // Store a reference to the google map instance in state
        map.setOptions({
            zoomControlOptions: {
                position: window.google.maps.ControlPosition.RIGHT_TOP
            }
        });
        setMapRef(map);
        // Fit map bounds to contain all markers
        fitBounds(map);
    };
    var setMapBounds = function(e, pos) {
        e.preventDefault();
        var searchBounds = new window.google.maps.LatLngBounds(), latlng = new window.google.maps.LatLng(pos.lat, pos.lng);
        searchBounds.extend(latlng);
        mapRef.setCenter(searchBounds.getCenter());
    };
    var renderMap = function() {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* GoogleMap */.b6, {
                // Do stuff on map initial laod
                onLoad: loadHandler,
                // Save the current center position in state
                center: center,
                zoom: zoom,
                mapContainerStyle: {
                    height: "100%",
                    width: "100%"
                },
                options: mapOptions,
                children: [
                    !displayLocation && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Marker */.Jx, {
                        position: defaultPlace.pos,
                        onLoad: function(marker) {
                            return markerLoadHandler(marker, defaultPlace);
                        }
                    }),
                    displayLocation && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Marker */.Jx, {
                        position: displayLocation.pos,
                        onLoad: function(marker) {
                            return markerLoadHandler(marker, displayLocation);
                        }
                    })
                ]
            })
        }));
    };
    return isLoaded ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()("locator-map", "h-full", "w-full"),
        children: isLoaded && displayLocation ? renderMap() : "Loading..."
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var locator_map = (LocatorMap);

// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 27 modules
var motion_minimal = __webpack_require__(6139);
// EXTERNAL MODULE: ./node_modules/react-geocode/lib/index.js
var lib = __webpack_require__(2948);
;// CONCATENATED MODULE: ./components/modules/contact-form.js











function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function contact_form_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function contact_form_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            contact_form_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
lib/* default.setApiKey */.Z.setApiKey("AIzaSyCpivuPCu-jAq3DzWTQFu8o8TcBac0Dm0k");
var contact_form_libraries = [
    "places"
];
var ContactForm = function(param) {
    var _data = param.data, data = _data === void 0 ? {} : _data;
    var introText = data.introText, primaryImage = data.primaryImage;
    var ref7 = (0,react.useState)(false), isLoading = ref7[0], setIsLoading = ref7[1];
    var ref1 = (0,react.useState)(1), step = ref1[0], setStep = ref1[1];
    var ref2 = (0,react.useState)(null), searchBoxRef = ref2[0], setSearchBoxRef = ref2[1];
    var ref3 = (0,react.useState)(null), selectedPlace = ref3[0], setSelectedPlace = ref3[1];
    var ref4 = (0,react.useState)(false), hasValidAddress = ref4[0], setHasValidAdress = ref4[1];
    var ref5 = (0,react.useState)({
        address: "",
        postalCode: "",
        firstName: "",
        lastName: "",
        telephone: "",
        email: "",
        customerType: "",
        urgency: ""
    }), validationErrors = ref5[0], setValidationErrors = ref5[1];
    var ref6 = (0,react.useState)({
        address: "",
        postalCode: "",
        firstName: "",
        lastName: "",
        telephone: "",
        email: "",
        customerType: "",
        urgency: ""
    }), contactInfo = ref6[0], setContactInfo = ref6[1];
    var isLoaded = (0,esm/* useLoadScript */.Db)({
        // Enter your own Google Maps API key
        googleMapsApiKey: "AIzaSyCpivuPCu-jAq3DzWTQFu8o8TcBac0Dm0k",
        libraries: contact_form_libraries
    }).isLoaded;
    var confirmAddress = function() {
        // we need a postal code, so if there's no postal code, lets geocode the string
        if (!selectedPlace) {
            lib/* default.fromAddress */.Z.fromAddress(contactInfo.address).then(function(response) {
                var _location = response.results[0].geometry.location, lat = _location.lat, lng = _location.lng;
                var newSelectedPlace = {
                    pos: {
                        lat: lat,
                        lng: lng
                    }
                };
                setSelectedPlace(newSelectedPlace);
            }, function(error) {
                console.error(error);
            });
        }
        // validate address before continuing
        var valid = true;
        if (contactInfo["address"]) {
            if (!contactInfo["address"].match(/^\d/)) {
                valid = false;
                setValidationErrors(contact_form_objectSpread({}, validationErrors, {
                    address: "Please begin your address with a street number."
                }));
            }
        }
        if (valid) {
            setStep(2);
        }
    };
    var searchBoxPlacesChanged = function() {
        var ref;
        var currPlace = searchBoxRef.getPlaces()[0];
        var newSelectedPlace = {
            id: currPlace.place_id,
            pos: {
                lat: currPlace.geometry.location.lat(),
                lng: currPlace.geometry.location.lng()
            }
        };
        var postalCodeComponent = currPlace.address_components.filter(function(component, idx) {
            if (component.types.includes("postal_code")) {
                return component;
            }
        });
        setContactInfo(contact_form_objectSpread({}, contactInfo, {
            address: currPlace.formatted_address,
            postalCode: (ref = postalCodeComponent[0]) === null || ref === void 0 ? void 0 : ref.short_name
        }));
        setSelectedPlace(newSelectedPlace);
    };
    var searchBoxLoadHandler = function(searchBox) {
        setSearchBoxRef(searchBox);
    };
    var handleChange = function(event) {
        setValidationErrors(contact_form_defineProperty({}, event.target.name, ""));
        setContactInfo(contact_form_objectSpread({}, contactInfo, contact_form_defineProperty({}, event.target.name, event.target.value)));
    };
    var handleSubmit = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(e) {
            var form, valid, isValidZip, rawResponse, content;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        form = contactInfo, valid = true;
                        // validate postal code is numeric
                        if (contactInfo["postalCode"]) {
                            isValidZip = /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(contactInfo["postalCode"]);
                            if (!isValidZip) {
                                valid = false;
                                setValidationErrors(contact_form_objectSpread({}, validationErrors, {
                                    postalCode: "Please enter a valid postal code."
                                }));
                            }
                        }
                        if (contactInfo["address"]) {
                            if (!contactInfo["address"].match(/^\d/)) {
                                valid = false;
                                setValidationErrors(contact_form_objectSpread({}, validationErrors, {
                                    address: "Please begin your address with a street number."
                                }));
                            }
                        }
                        if (!contactInfo["customerType"]) {
                            valid = false;
                            setValidationErrors(contact_form_objectSpread({}, validationErrors, {
                                customerType: "Please select an option."
                            }));
                        }
                        if (!contactInfo["urgency"]) {
                            valid = false;
                            setValidationErrors(contact_form_objectSpread({}, validationErrors, {
                                urgency: "Please select an option."
                            }));
                        }
                        if (!valid) {
                            _ctx.next = 18;
                            break;
                        }
                        // add loader
                        if (window && window.gtag) {
                            window.gtag("event", "order_form_submit");
                        }
                        setIsLoading(true);
                        _ctx.next = 11;
                        return fetch("/api/dwell/process-form", {
                            method: "POST",
                            headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify(form)
                        });
                    case 11:
                        rawResponse = _ctx.sent;
                        _ctx.next = 14;
                        return rawResponse.json();
                    case 14:
                        content = _ctx.sent;
                        if (content) {
                            window.scrollTo(0, 0);
                            window.location.href = "/thank-you";
                        }
                        _ctx.next = 19;
                        break;
                    case 18:
                        return _ctx.abrupt("return", false);
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (step == 2) {
            setTimeout(function() {
                setStep(3);
            }, 2000);
        }
        if (step == 3) {
            setTimeout(function() {
                setStep(4);
            }, 3000);
        }
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: classnames_default()("contact-form", "md:h-[100px]", "md:min-h-[calc(100vh-var(--header-height))]"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()("grid", "grid-cols-20", "md:h-full"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()("col-span-20", "md:col-span-10", "flex", "flex-col", "place-content-center", "h-[300px]", "overflow-hidden", "md:h-full", "text-center"),
                    children: [
                        step === 4 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("h-full", "bg-[#dddddd]"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(locator_map, {
                                displayLocation: selectedPlace
                            })
                        }),
                        step !== 4 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative h-full",
                            children: primaryImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(photo/* default */.Z, {
                                photo: primaryImage,
                                width: 1200,
                                layout: "fill"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()("col-span-16", "col-start-3", "md:col-span-8", "md:col-start-12", "flex", "flex-col", "place-content-center", "h-auto", "md:h-full", "py-[20px]"),
                    "data-theme": "gray",
                    children: [
                        step === 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()("mx-auto", "form"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: classnames_default()("text-lg-3", "uppercase", "text-center", "mb-[50px]", "mx-auto"),
                                    children: introText
                                }),
                                isLoaded && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "input-wrap",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            children: "Address"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* StandaloneSearchBox */.Zk, {
                                            onLoad: searchBoxLoadHandler,
                                            onPlacesChanged: searchBoxPlacesChanged,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                onChange: handleChange,
                                                name: "address",
                                                type: "text",
                                                value: contactInfo.address,
                                                placeholder: "Enter your address"
                                            })
                                        }),
                                        validationErrors["address"] && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classnames_default()("text-[#ff0000]"),
                                            children: validationErrors["address"]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "input-wrap text-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        disabled: !contactInfo.address,
                                        onClick: function() {
                                            return confirmAddress();
                                        },
                                        className: classnames_default()("text", "uppercase"),
                                        children: [
                                            "Next",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classnames_default()("long-arrow"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                                    name: "LongArrow",
                                                    color: "#000000",
                                                    viewBox: "0 0 47 13"
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        step === 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                            animate: {
                                opacity: 1
                            },
                            initial: {
                                opacity: 0
                            },
                            transition: {
                                duration: 1
                            },
                            className: classnames_default()("mx-auto", "form"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()("text-lg-2-mobile", "md:text-lg-2", "text-center", "mb-[50px]", "max-w-[50%]", "mx-auto"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(phrase/* default */.Z, {
                                    phrase: "Locating - your property",
                                    vertical: "true",
                                    dividerMaxWidth: "300px",
                                    hideLast: true,
                                    typeStyle: "text-jumbo-mobile md:text-jumbo"
                                })
                            })
                        }),
                        step === 3 && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                            animate: {
                                opacity: 1
                            },
                            initial: {
                                opacity: 0
                            },
                            transition: {
                                duration: 2
                            },
                            className: classnames_default()("mx-auto", "form"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()("text-lg-2-mobile", "md:text-lg-2", "text-center", "mb-[50px]", "max-w-[50%]", "mx-auto"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(phrase/* default */.Z, {
                                    phrase: "Address Found",
                                    hideLast: true,
                                    typeStyle: "text-jumbo-mobile md:text-jumbo"
                                })
                            })
                        }),
                        step === 4 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                            className: classnames_default()("mx-auto", "form"),
                            onSubmit: handleSubmit,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: classnames_default()("text-lg-3", "uppercase", "text-center", "mb-[50px]", "mx-auto"),
                                    children: "Tell Us More About Yourself"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "grid md:grid-cols-2 md:gap-5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "input-wrap col-span-1",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    htmlFor: "firstName",
                                                    children: "First Name"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    onChange: handleChange,
                                                    name: "firstName",
                                                    id: "firstName",
                                                    type: "text",
                                                    value: contactInfo.firstName,
                                                    required: true
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "input-wrap col-span-1",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    htmlFor: "lastName",
                                                    children: "Last Name"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    onChange: handleChange,
                                                    name: "lastName",
                                                    id: "lastName",
                                                    type: "text",
                                                    value: contactInfo.lastName,
                                                    required: true
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "input-wrap",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            htmlFor: "telephone",
                                            children: "Telephone"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            onChange: handleChange,
                                            name: "telephone",
                                            id: "telephone",
                                            type: "tel",
                                            value: contactInfo.telephone,
                                            required: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "input-wrap",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            htmlFor: "email",
                                            children: "Email"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            onChange: handleChange,
                                            name: "email",
                                            id: "email",
                                            type: "email",
                                            required: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "input-wrap",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            htmlFor: "address",
                                            children: "Address"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            onChange: handleChange,
                                            name: "address",
                                            id: "address",
                                            type: "address",
                                            value: contactInfo.address,
                                            required: true,
                                            disabled: true
                                        }),
                                        validationErrors["address"] && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classnames_default()("text-[#ff0000]"),
                                            children: validationErrors["address"]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "input-wrap",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            htmlFor: "address",
                                            children: "Postal Code"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            onChange: handleChange,
                                            name: "postalCode",
                                            id: "postalCode",
                                            type: "postalCode",
                                            value: contactInfo.postalCode,
                                            required: true
                                        }),
                                        validationErrors["postalCode"] && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classnames_default()("text-[#ff0000]"),
                                            children: validationErrors["postalCode"]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "input-wrap select",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            htmlFor: "customerType",
                                            children: "I am a"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                            onChange: handleChange,
                                            id: "customerType",
                                            name: "customerType",
                                            value: contactInfo.customerType,
                                            required: true,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    children: "----"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: "a Homeowner",
                                                    children: "Homeowner"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: "Future Homeowner",
                                                    children: "Future homeowner"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: "Real Estate Agent",
                                                    children: "Real estate agent"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: "Real Estate Developer",
                                                    children: "Real estate developer"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: "a Homeowner with an existing ADU",
                                                    children: "Homeowner with an existing ADU"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "icon",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                width: "24",
                                                height: "24",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                        cx: "12",
                                                        cy: "12",
                                                        r: "11.5",
                                                        stroke: "#252524"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M7 10L12 15L17 10",
                                                        stroke: "#252524"
                                                    })
                                                ]
                                            })
                                        }),
                                        validationErrors["customerType"] && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classnames_default()("text-[#ff0000]"),
                                            children: validationErrors["customerType"]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "input-wrap select",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            htmlFor: "urgency",
                                            children: "Desired project start date?"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                            onChange: handleChange,
                                            name: "urgency",
                                            id: "urgency",
                                            value: contactInfo.urgency,
                                            required: true,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    children: "----"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: "ASAP!",
                                                    children: "ASAP"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: "1-3 Months",
                                                    children: "1-3 months"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: "3-6 Months",
                                                    children: "3-6 months"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: "6 Months+",
                                                    children: "6+ months"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "icon",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                width: "24",
                                                height: "24",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                        cx: "12",
                                                        cy: "12",
                                                        r: "11.5",
                                                        stroke: "#252524"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M7 10L12 15L17 10",
                                                        stroke: "#252524"
                                                    })
                                                ]
                                            })
                                        }),
                                        validationErrors["urgency"] && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classnames_default()("text-[#ff0000]"),
                                            children: validationErrors["urgency"]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "input-wrap text-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: classnames_default()("text", "uppercase"),
                                        disabled: isLoading,
                                        children: isLoading ? "Submitting..." : "Submit"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ var contact_form = (ContactForm);


/***/ })

}]);